import { Store } from "@ngxs/store";
import { SetAccessibleModules } from "@state/common/common.action";
import { map, of } from "rxjs";

import { inject } from "@angular/core";
import { type ActivatedRouteSnapshot, type ResolveFn } from "@angular/router";

export const modulesResolver: ResolveFn<boolean> = (
  route: ActivatedRouteSnapshot
) => {
  const store = inject(Store);

  const tenantId = route.paramMap.get("tenantId");

  if (!tenantId) {
    return of(false);
  }

  return store
    .dispatch(new SetAccessibleModules(tenantId))
    .pipe(map(() => true));
};
